<template>
  <aside
    ref="card"
    class="campaign ph-no-capture"
    data-campaign=""
    :class="['content-campaign-' + presentation.theme, compact || presentation.template === 'compact-strip' ? 'content-campaign-compact' : 'content-campaign-' + presentation.template, { 'content-campaign-has-image': showImage }]"
    :dir="locale === 'en' ? 'ltr' : 'rtl'"
    :style="{ textAlign: locale === 'en' ? 'left' : 'right' }"
    :aria-label="presentation.label"
  >
    <button
      class="content-campaign-dismiss"
      type="button"
      :aria-label="words.dismiss"
      @click="$emit('dismiss', presentation.campaignId)"
    >
      ×
    </button>
    <picture
      v-if="showImage"
      class="content-campaign-visual"
    >
      <source
        v-if="!previewImageUrl && presentation.image.mobileUrl"
        media="(max-width:767px)"
        :srcset="presentation.image.mobileUrl"
      >
      <img
        :src="previewImageUrl || presentation.image.url"
        :alt="presentation.image.alt || ''"
        :width="presentation.image.width || 480"
        :height="presentation.image.height || 320"
        loading="lazy"
        decoding="async"
        @error="imageFailed = true"
      >
    </picture>
    <div class="content-campaign-copy">
      <span class="content-campaign-eyebrow"><bdi dir="auto">{{ presentation.label }}</bdi></span>
      <h3 class="content-campaign-title">
        <bdi dir="auto">{{ presentation.title }}</bdi>
      </h3>
      <p
        v-if="presentation.body"
        class="content-campaign-description"
      >
        <bdi dir="auto">{{ presentation.body }}</bdi>
      </p>
      <div class="content-campaign-actions">
        <a
          href="#"
          class="content-campaign-primary"

          @click.prevent="$emit('action', presentation.primaryAction.id)"
        ><bdi dir="auto">{{ presentation.primaryAction.label }}</bdi> <span aria-hidden="true">{{ locale === 'en' ? '→' : '←' }}</span><span
          v-if="presentation.primaryAction.openInNewTab"
          class="sr-only"
        > {{ words.newTab }}</span></a>
        <a
          v-if="presentation.secondaryAction"
          href="#"
          class="content-campaign-secondary"

          @click.prevent="$emit('action', presentation.secondaryAction.id)"
        ><bdi dir="auto">{{ presentation.secondaryAction.label }}</bdi><span
          v-if="presentation.secondaryAction.openInNewTab"
          class="sr-only"
        > {{ words.newTab }}</span></a>
      </div>
    </div>
  </aside>
</template>
<script>
export default {
  props: {
    presentation: { type: Object, required: true }, locale: { type: String, required: true }, compact: Boolean, previewImageUrl: { type: String, default: '' },
  },
  data() { return { imageFailed: false } },
  computed: {
    showImage() { return !this.compact && this.presentation.template === 'image-banner' && !this.imageFailed && this.presentation.image && ((this.previewImageUrl && /^blob:/.test(this.previewImageUrl)) || /^https:\/\//.test(this.presentation.image.url)) },
    words() { return { fa: { dismiss: 'بستن این پیشنهاد', newTab: '(در تب جدید)' }, ar: { dismiss: 'إغلاق هذا الاقتراح', newTab: '(في علامة تبويب جديدة)' }, en: { dismiss: 'Dismiss this offer', newTab: '(opens in a new tab)' } }[this.locale] },
  },
  watch: { previewImageUrl() { this.imageFailed = false }, 'presentation.campaignId': function resetCampaignImage() { this.imageFailed = false }, 'presentation.revision': function resetRevisionImage() { this.imageFailed = false } },
}
</script>
<style scoped>
.campaign { position: relative; margin: 30px 0; border: 1px solid #d7e9ea; border-radius: 20px; padding: 30px; background: #edf7f8; color: #31484c; text-align: start; font-family: IRANSans, Tahoma, sans-serif; overflow-wrap: anywhere; }
.campaign[dir='ltr'] { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
.content-campaign-soft-rose { background: #fcf3f3; border-color: #efdfdf; }
.content-campaign-neutral { background: #f6f7f7; border-color: #e1e5e5; }
.content-campaign-image-banner { background: linear-gradient(115deg, #edf7f8, #f8fcfc); border-inline-start: 4px solid #69afb4; }
.content-campaign-visual { display: block; border-radius: 12px; overflow: hidden; }
.content-campaign-visual img { display: block; width: 100%; height: auto; max-height: 260px; object-fit: cover; }
.content-campaign-image-banner.content-campaign-has-image { display: grid; grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr); gap: 24px; align-items: center; }
.content-campaign-copy, .content-campaign-title, .content-campaign-description { text-align: inherit; }
.content-campaign-copy { min-width: 0; }
.campaign .content-campaign-copy { padding-inline-end: 18px; padding-inline-start: 0; }
.content-campaign-eyebrow { display: block; color: #526f73; font-size: 12px; line-height: 1.8; }
.campaign .content-campaign-title, #contentBox .campaign .content-campaign-title { margin: 8px 0; font-size: 22px; line-height: 1.7; font-weight: 700; color: #263f43; }
.campaign .content-campaign-description, #contentBox .campaign .content-campaign-description { margin: 8px 0 20px; line-height: 1.95; font-size: 14px; }
.content-campaign-actions { position: static; display: flex; flex-wrap: wrap; align-items: center; gap: 8px 18px; }
.campaign .content-campaign-actions a, #contentBox .campaign .content-campaign-actions a { min-height: 44px; display: inline-flex; align-items: center; justify-content: center; gap: 20px; text-decoration: none; line-height: 1.7; font-size: 14px; }
.campaign .content-campaign-actions .content-campaign-primary, #contentBox .campaign .content-campaign-actions .content-campaign-primary { padding: 10px 18px; background: #176f76; color: #fff; border-radius: 10px; }
.content-campaign-primary:hover { background: #125a60; }
.campaign .content-campaign-secondary, #contentBox .campaign .content-campaign-secondary { color: #176f76; text-decoration: underline; text-underline-offset: 4px; }
.content-campaign-dismiss { position: absolute; top: 8px; width: 44px; height: 44px; border: 0; border-radius: 50%; background: transparent; color: #526f73; font-size: 25px; }
.campaign .content-campaign-dismiss { inset-inline-end: 8px; inset-inline-start: auto; }
.content-campaign-dismiss:hover { background: #ddeced; }
button:focus-visible, a:focus-visible { outline: 3px solid #177b84; outline-offset: 3px; }
.content-campaign-compact { padding: 20px 24px; border-radius: 14px; }
.campaign.content-campaign-compact .content-campaign-title, #contentBox .campaign.content-campaign-compact .content-campaign-title { font-size: 17px; }
.campaign.content-campaign-compact .content-campaign-description, #contentBox .campaign.content-campaign-compact .content-campaign-description { margin-bottom: 12px; font-size: 13px; }
@media(max-width:767px) { .content-campaign-image-banner.content-campaign-has-image { grid-template-columns: 1fr; gap: 18px; } .content-campaign-visual img { max-height: 210px; } .campaign { padding: 24px 18px; border-radius: 16px; } .campaign .content-campaign-title, #contentBox .campaign .content-campaign-title { font-size: 19px; } .content-campaign-actions { align-items: stretch; } .campaign .content-campaign-actions a { width: 100%; } .campaign .content-campaign-copy { padding-inline-end: 12px; } }
@media(prefers-reduced-motion:reduce) { * { scroll-behavior: auto; } }
</style>
